import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { CompanyEntity } from './company.entity';
import { PriceContractCategoryClientEntity } from './price-contract-category-client.entity';
import { PriceContractCategoryItemEntity } from './price-contract-category-item.entity';
import { PriceContractClientEntity } from './price-contract-client.entity';
import { PriceContractItemEntity } from './price-contract-item.entity';

@Index('fk_company__id', ['fkCompanyId'], {})
@Index('price_contract_externalId_uindex', ['deletedUserId', 'externalId'], {
	unique: true,
})
@Entity('price_contract')
export class PriceContractEntity extends BaseEntity {
	@Column('varchar', { name: 'externalId', nullable: true, length: 64 })
	public externalId!: string | null;

	@Column('varchar', { name: 'contractNumber', nullable: true, length: 64 })
	public contractNumber!: string | null;

	@Column('text', { name: 'description', nullable: true })
	public description!: string | null;

	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@Column('date', { name: 'startDate', nullable: true })
	public startDate!: string | null;

	@Column('date', { name: 'endDate', nullable: true })
	public endDate!: string | null;

	@Column('int', { name: 'priority', unsigned: true })
	public priority!: number;

	@Column('datetime', { name: 'lastImportDate', nullable: true })
	public lastImportDate!: Date | null;

	@Column('int', { name: 'fk_company__id', nullable: true, unsigned: true })
	public fkCompanyId!: number | null;

	@ManyToOne(() => CompanyEntity, (company) => company.priceContracts, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_company__id', referencedColumnName: 'id' }])
	public company!: CompanyEntity;

	@OneToMany(
		() => PriceContractCategoryClientEntity,
		(priceContractCategoryClient) => priceContractCategoryClient.priceContract,
	)
	public priceContractCategoryClients!: Array<PriceContractCategoryClientEntity>;

	@OneToMany(
		() => PriceContractCategoryItemEntity,
		(priceContractCategoryItem) => priceContractCategoryItem.priceContract,
	)
	public priceContractCategoryItems!: Array<PriceContractCategoryItemEntity>;

	@OneToMany(
		() => PriceContractClientEntity,
		(priceContractClient) => priceContractClient.priceContract,
	)
	public priceContractClients!: Array<PriceContractClientEntity>;

	@OneToMany(
		() => PriceContractItemEntity,
		(priceContractItem) => priceContractItem.priceContract,
	)
	public priceContractItems!: Array<PriceContractItemEntity>;
}
